import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/training-plans',
      name: 'Planes de Entrenamiento',
      component: () => import('../components/training_plans/table.vue')
    },
  {
    path: '/menu',
    name: 'Platillos',
    component: () => import('../components/menu/table.vue')
  },
  {
    path: '/foods',
    name: 'Alimentos',
    component: () => import('../components/foods/container.vue')
  },
  {
    path: '/',
    name: 'Videos',
    component: () => import('../components/videos/container.vue')
  },
  {
    path: '/calendar',
    name: 'Calendario',
    component: () => import('../components/activities/calendar.vue')
  },
  {
    path: '/measurements',
    name: 'Medidas Corporales',
    component: () => import('../components/measurements/container.vue')
  },
  {
    path: '/clients',
    name: 'Pacientes',
    component: () => import('../components/clients/table.vue')
  },
  {
    path: '/client/:id',
    name: 'Paciente',
    component: () => import('../components/clients/client/container.vue')
  },
  {
    path: '/videos',
    name: 'Videos',
    component: () => import('../components/videos/container.vue')
  },
  {
    path: '/videos-by-categories/:id',
    name: 'Videos por Catgeoría',
    component: () => import('../components/videos/videos_by_category.vue')
  },
  {
    path:'/training',
    name:'Entrenamiento',
    component: () => import('../components/training/container.vue')
  },
  {
    path:'/meal-plans',
    name:'Planes Alimenticios',
    component: () => import('../components/meal_plans/container.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
